import { useState } from 'react';
import { CloseIcon, StarOutlinedIcon } from '@repo/atomic-components';

/**
 * Tells users MeRMAIDD is on a new address so they re-bookmark it.
 *
 * The X only hides it for the current visit — dismissal is plain component state, not
 * persisted — so the notice is back on the next refresh or the next time the user lands
 * on the case list. That's deliberate: it keeps nudging people who haven't re-bookmarked
 * yet, while still letting them clear it out of the way whenever it's in their path.
 *
 * Sits at the very top of the page, above the nav header. Because it's the first thing in
 * the document, dismissing it drops focus back to the start of the page — i.e. the logo /
 * nav, which is where Tab would have carried on anyway — so no focus handoff is needed.
 */
export const MermaiddMovedBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  return (
    <div className="bg-fletchers-green-500 text-fletchers-white relative flex min-h-14 w-full shrink-0 items-center justify-center px-12 py-2 text-center text-sm font-medium">
      <p className="m-0 text-balance">
        MeRMAIDD has moved - please update your bookmark by hitting star{' '}
        <StarOutlinedIcon aria-hidden width={16} height={16} className="inline-block align-[-3px]" /> in the address bar
      </p>
      <div className="absolute inset-y-0 right-2 flex items-center">
        <button
          type="button"
          aria-label="Dismiss"
          onClick={handleDismiss}
          className="text-fletchers-white hover:bg-fletchers-white/15 focus-visible:outline-fletchers-white flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors focus-visible:outline-2"
        >
          <CloseIcon aria-hidden />
        </button>
      </div>
    </div>
  );
};
